import { render, staticRenderFns } from "./BookMatchSelectCustomerProfile.vue?vue&type=template&id=318a89d6&scoped=true&"
import script from "./BookMatchSelectCustomerProfile.vue?vue&type=script&lang=js&"
export * from "./BookMatchSelectCustomerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a89d6",
  null
  
)

export default component.exports